// Module
var code = "<span class=\"clip-select select-bordered-caret\" ng-class=\"vm.className\"> <select class=\"form-control\" ng-change=\"vm.onSelect({ $e: { fileId: vm.fileId } })\" ng-options=\"file.id as file.name for file in vm.insuranceFiles\" ng-model=\"vm.fileId\" required> </select> </span> ";
// Exports
module.exports = code;